import { Toaster as Sonner } from "sonner" // Only import Toaster from sonner
import { useTheme } from "@/context/ThemeContext" // Import useTheme

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme() // Use the theme context

  return (
    <Sonner
      closeButton
      theme={resolvedTheme === 'dark' ? 'dark' : 'light'}
      position="bottom-right"
      className="toaster group"
      toastOptions={{
        unstyled: false,
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:relative",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:!bg-primary group-[.toast]:!text-primary-foreground group-[.toast]:hover:!bg-primary/90 group-[.toast]:!rounded-md group-[.toast]:!text-sm group-[.toast]:!font-medium group-[.toast]:!h-8 group-[.toast]:!px-3",
          cancelButton:
            "group-[.toast]:!bg-background group-[.toast]:!text-foreground group-[.toast]:!border group-[.toast]:!border-solid group-[.toast]:!border-input group-[.toast]:hover:!bg-accent group-[.toast]:hover:!text-accent-foreground group-[.toast]:!rounded-md group-[.toast]:!text-sm group-[.toast]:!font-medium group-[.toast]:!h-8 group-[.toast]:!px-3",
          closeButton:
            "!absolute !top-1.5 !right-1.5 !left-auto !transform-none !border-none !bg-transparent !text-muted-foreground hover:!bg-accent hover:!text-foreground !rounded-md !h-6 !w-6 !p-0",
          success:
            "group-[.toaster]:text-success",
          error:
            "group-[.toaster]:text-danger",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
